import React from 'react';
import "../LandingPage.css";
import { Card } from 'antd';

const TermsPage = () => {
    return (
        <div style={{ paddingLeft: "20px", paddingRight: "20px", paddingBottom: "60px", paddingTop: "60px" }}>
            <Card
                style={{
                    marginTop: "60px",
                    marginBottom: "60px",
                    maxWidth: 800,
                    margin: "auto",
                    minWidth: 280,
                    textAlign: "left",
                    boxShadow: "0 8px 16px rgba(0,0,0,0.1)"
                }}>
                <div style={{ padding: "20px", maxWidth: '800px', margin: '0 auto' }}>
                    <h1>Vilkår og betingelser for bruk av Kipler</h1>
                    <p>Dato for siste oppdatering: 11.02.2025</p>

                    <h3>1. Avtale og aksept</h3>
                    <p>Disse vilkårene og betingelsene ("Vilkårene") regulerer bruken av Kipler ("Tjenesten"), levert av Kipler AS ("Vi", "Vår", "Oss"). Ved å registrere deg for eller bruke Tjenesten, aksepterer du å være bundet av Vilkårene. Hvis du ikke aksepterer Vilkårene, kan du ikke bruke Tjenesten.</p>

                    <h3>2. Tjenestens innhold og funksjonalitet</h3>
                    <ul>
                        <li>Mulighet for å ta opp lyd fra klientmøter.</li>
                        <li>Automatisk transkripsjon og anonymisering av lydopptak.</li>
                        <li>Analyse og generering av sammendrag ved bruk av kunstig intelligens.</li>
                        <li>Lagring og administrasjon av klientdata.</li>
                    </ul>
                    <p>Tjenesten er beregnet for psykologer og annet helsepersonell som overholder gjeldende lover og forskrifter, inkludert GDPR.</p>

                    <h3>3. Brukerens ansvar</h3>
                    <ul>
                        <li>Å sikre at all bruk av Tjenesten er i samsvar med gjeldende lover og forskrifter.</li>
                        <li>Å innhente samtykke fra klienter før behandling av personopplysninger.</li>
                        <li>Å beskytte påloggingsinformasjon og unngå uautorisert tilgang til din konto.</li>
                        <li>Å oppgi riktig og oppdatert informasjon ved registrering.</li>
                    </ul>

                    <h3>4. Priser og betaling</h3>
                    <p>Priser for bruk av Tjenesten vil bli oppgitt på vår nettside eller i avtale med deg som bruker.</p>
                    <p>Betaling må skje i henhold til de angitte betalingsvilkårene. Ved manglende betaling kan vi suspendere eller avslutte din tilgang til Tjenesten.</p>

                    <h3>5. Personvern og databeskyttelse</h3>
                    <p>Vår behandling av personopplysninger skjer i samsvar med vår <a href="/privacy">Personvernerklæring</a>. Vi fungerer som databehandler, og du som bruker er behandlingsansvarlig.</p>

                    <h3>6. Oppsigelse og avslutning</h3>
                    <p>Du kan avslutte din bruk av Tjenesten ved å sende en skriftlig oppsigelse. Vi kan avslutte din tilgang ved brudd på Vilkårene.</p>

                    <h3>7. Ansvarsbegrensning</h3>
                    <p>Tjenesten leveres "som den er", og vi fraskriver oss ansvar for indirekte skader eller tap.</p>

                    <h3>8. Endringer i vilkårene</h3>
                    <p>Vi forbeholder oss retten til å endre Vilkårene. Fortsatt bruk innebærer aksept av de nye vilkårene.</p>

                    <h2>Del 2: Databehandleravtale</h2>
                    <p>Denne databehandleravtalen ("Avtalen") er inngått mellom:</p>
                    <ul>
                        <li>Behandlingsansvarlig: Brukeren ("Behandlingsansvarlig"), som bruker tjenesten til å administrere og analysere klientdata, og som er ansvarlig for innhenting av klientens samtykke i henhold til GDPR.</li>
                        <li>Databehandler: Kipler AS ("Databehandler"), som leverer en webapplikasjon for lydopptak, transkripsjon, anonymisering og analyse.</li>
                    </ul>

                    <h3>1. Formål</h3>
                    <p>Databehandler behandler personopplysninger på vegne av Behandlingsansvarlig for følgende formål:</p>
                    <ul>
                        <li>Lagring av klientinformasjon (navn, e-post, telefonnummer).</li>
                        <li>Transkripsjon og anonymisering av lydopptak.</li>
                        <li>Analyse og generering av journalnotater ved bruk av kunstig intelligens.</li>
                    </ul>

                    <h3>2. Behandlingens art og varighet</h3>
                    <p>Behandlingen skjer så lenge det er nødvendig for formålet eller i henhold til lovkrav.</p>

                    <h3>3. Databehandlerens plikter</h3>
                    <p>Databehandler skal:</p>
                    <ul>
                        <li>Behandle personopplysninger kun etter instruks fra Behandlingsansvarlig.</li>
                        <li>Implementere tekniske og organisatoriske tiltak for å beskytte data.</li>
                        <li>Bistå med å etterleve rettigheter under GDPR.</li>
                    </ul>

                    <h3>4. Lagring og sletting</h3>
                    <p>Lydopptak slettes automatisk etter transkripsjon, og alle data kan slettes på forespørsel.</p>

                    <h3>5. Underleverandører</h3>
                    <p>Databehandler benytter seg av følgende underleverandører:</p>
                    <ul>
                        <li>Google Cloud Platform: Hosting og lagringstjenester, med datasentre i EU/EØS.
                        </li>
                        <li>Cloud Run og Flask-tjenester: For transkripsjon av lydopptak.
                        </li>
                        <li>ChatGPT (helsemodell i tråd med GDPR): For analyser og generering av sammendrag.</li>
                    </ul>
                    <p>Databehandler sikrer at underleverandørene etterlever GDPR, og at data ikke overføres utenfor EU/EØS uten passende garantier. Behandlingsansvarlig skal informeres skriftlig og godkjenne nye underleverandører.</p>

                    <h3>6. Sikkerhetstiltak</h3>
                    <p>Databehandler har implementert følgende sikkerhetstiltak:
                    </p>
                    <ul>
                        <li>Kryptering av data både under transport og i hvile.
                        </li>
                        <li>Tilgangskontroll for å begrense dataadgang til autorisert personell.
                        </li>
                        <li>Regelmessige revisjoner av sikkerhetsprosedyrer og systemer.</li>
                        <li>Mekanisme for sletting av data fra systemene ved forespørsel eller etter bruk.
                        </li>
                    </ul>

                    <h3>9. Gjeldende lov og tvisteløsning</h3>
                    <p>Disse Vilkårene er underlagt norsk lovgivning. Eventuelle tvister som oppstår i forbindelse med disse Vilkårene skal behandles av Oslo tingrett som verneting, med mindre annet følger av ufravikelig lovgivning.
                    </p>
                </div>
            </Card>
        </div>
    );
};

export default TermsPage;
